import { useState } from 'react'

import { maskedPinUtils } from 'components/MaskedPin/utils'

import { ReactComponent as IconShowPassword } from 'assets/icons/IconShowPassword.svg'
import { ReactComponent as IconHidePassword } from 'assets/icons/IconHidePassword.svg'

const MaskedPin = ({ pin }) => {
  const [isPinCodeVisible, setIsPinCodeVisible] = useState(false)

  const maskedPinSign = maskedPinUtils.createMaskedPinSign(pin)
  const pinCode = isPinCodeVisible ? pin : maskedPinSign
  const icon = isPinCodeVisible ? (
    <IconHidePassword />
  ) : (
    <IconShowPassword />
  )

  const onClickIcon = (event) => {
    event.stopPropagation()
    setIsPinCodeVisible((prev) => !prev)
  }

  return (
    <div className="masked-pin">
      <p className="masked-pin__text">{pinCode}</p>
      <button className="masked-pin__icon" onClick={onClickIcon}>
        {icon}
      </button>
    </div>
  )
}

export default MaskedPin
